import React from "react";
import { Box, Typography } from "@mui/material";
import SingleDateTimePicker from "../../../Components/SingleDateTimePicker";
import SectionIconTile from "../../../Components/SectionIconTile";
import { TimelineIcon } from "../../../Components/Icons/SectionIcons";
import { getTimelineOrderErrors } from "../recordReplacementHelper";

const Field = ({ label, value, onChange, hasError, errorText }) => (
    <Box>
        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1A1A1A", mb: "6px" }}>
            {label}
            <span style={{ color: "#E5484D", marginLeft: 2 }}>*</span>
        </Typography>
        <SingleDateTimePicker value={value} onChange={onChange} hasError={hasError} />
        {hasError && (
            <Typography sx={{ fontSize: "12px", color: "#E5484D", mt: "4px" }}>
                {errorText}
            </Typography>
        )}
    </Box>
);

// Bus held up / Work start / Work end. busHeldUpAt drives the Bus Information
// metrics preview (watched by the page controller).
export default function TimelineSection({ timeline = {}, setTimeline = () => {}, errors = {} }) {
    // Reactive ordering check: surface the out-of-order message the moment a bad
    // date is picked, instead of staying silent until submit. Merged with the
    // parent's errors (which cover the required/empty case on submit).
    const orderErrors = getTimelineOrderErrors(timeline);
    const workStartError = errors.workStartAt || orderErrors.workStartAt;
    const workEndError = errors.workEndAt || orderErrors.workEndAt;
    return (
        <Box
            sx={{
                border: "1px solid #EAEAEA",
                borderRadius: "12px",
                padding: "24px 28px",
                backgroundColor: "#fff",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px", mb: "18px" }}>
                <SectionIconTile icon={<TimelineIcon />} />
                <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#1A1A1A" }}>
                    Timeline
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
                    gap: "20px",
                }}
            >
                <Field
                    label="Issue reported date time"
                    value={timeline.busHeldUpAt || null}
                    onChange={(val) => setTimeline({ busHeldUpAt: val })}
                    hasError={!!errors.busHeldUpAt}
                    errorText="Please select issue reported date and time"
                />
                <Field
                    label="Work start"
                    value={timeline.workStartAt || null}
                    onChange={(val) => setTimeline({ workStartAt: val })}
                    hasError={!!workStartError}
                    errorText={
                        typeof workStartError === "string"
                            ? workStartError
                            : "Please select work start date and time"
                    }
                />
                <Field
                    label="Work end"
                    value={timeline.workEndAt || null}
                    onChange={(val) => setTimeline({ workEndAt: val })}
                    hasError={!!workEndError}
                    errorText={
                        typeof workEndError === "string"
                            ? workEndError
                            : "Please select work end date and time"
                    }
                />
            </Box>
        </Box>
    );
}
